<template>
	<div>
		<v-row class="mb-0">
			<v-col lg="3" md="4" sm="6" cols="12">
				<div class="image">
					<v-img
						width="100%"
						max-width="100%"
						:src="product?.primaryImage?.url"
						class="cursor-pointer rounded"
						alt="product"
						@click="
							lightBox.visible = true;
							lightBox.index = 0;
						"
					/>
				</div>
				<div class="d-flex flex-wrap justify-sm-start justify-center align-center mt-2 mb-4">
					<v-img
						v-for="
							(image, i) in
							product?.images
								.filter(c => c.id !== product?.primaryImage?.id)
								.map(c => c.url)
						"
						:key="i"
						:width="95"
						:max-width="95"
						:height="95"
						:max-height="95"
						:src="image"
						class="cursor-pointer rounded mx-1 mt-2"
						alt="product"
						@click="
							lightBox.visible = true;
							lightBox.index = i + 1;
						"
					/>
					<vue-easy-lightbox
						:visible="lightBox.visible"
						:imgs="product?.images.map(c => c.url) ?? []"
						:index="lightBox.index"
						@hide="lightBox.visible = false"
					></vue-easy-lightbox>
				</div>
			</v-col>
			<v-col lg="9" md="8" sm="6" cols="12">
				<div class="d-flex flex-md-row flex-column-reverse flex-wrap justify-space-between align-md-center align-start">
					<h2>{{ product?.name }}</h2>
					<v-btn
						v-if="$vuetify.breakpoint.smAndUp"
						outlined
						exact
						class="pe-1"
						@click="$router.go(-1)"
					>
						{{$t('back')}}
						<v-icon>mdi-chevron-{{$i18n.locale === 'ar' ? 'left': 'right'}}</v-icon>
					</v-btn>
				</div>
				<div
					v-html="product?.description"
					class="ck-content"
				></div>
			</v-col>
		</v-row>

		<div v-if="!$vuetify.breakpoint.smAndUp" class="text-center mb-3">
			<v-btn
				outlined
				exact
				class="pe-1"
				@click="$router.go(-1)"
			>
				{{$t('back')}}
				<v-icon>mdi-chevron-{{$i18n.locale === 'ar' ? 'left' : 'right'}}</v-icon>
			</v-btn>
		</div>

		<!-- related products -->
		<template v-if="false">
			<h2 class="my-2">{{ $t("related-products") }}</h2>
			<v-row class="row pt-5">
				<v-col
					v-for="product in products.filter(c => c.slug !== $route.params.slug).slice(0, 4)"
					:key="product.id"
					md="3"
					sm="4"
					cols="6"
				>
					<product-card :product="product"/>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue';
import { mapGetters, mapState } from 'vuex';

export default {
	name: 'Product',

	components: { ProductCard },

	data() {
		return {
			lightBox: {
				visible: false,
				index: 0,
			}
		}
	},

	computed: {
		...mapState({
			products: state => state.products.products
		}),

		...mapGetters({
			getProductBySlug: 'products/getBySlug',
		}),

		product() {
			return this.getProductBySlug(this.$route.params.slug)
		},
	},
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
	cursor: pointer;
}
</style>
